import { PipeModule } from './../../../pipe/pipe.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RadioComponent } from './radio.component';



@NgModule({
  declarations: [RadioComponent],
  exports: [RadioComponent],
  imports: [
    IonicModule,
    CommonModule,
    PipeModule
  ]
})
export class RadioModule { }
